export class AppSettings {
    public static API_ENDPOINT='https://kbperfecta.com:57850/Perfecta.svc';
    //public static API_ENDPOINT='https://dev.kbperfecta.com:57850/Perfecta.svc';
    //public static API_ENDPOINT='http://200.69.13.85:57850/Perfecta.svc';
    //public static API_ENDPOINT='http://200.69.13.83:57850/Perfecta.svc';
    //public static API_ENDPOINT='http://localhost:57850/Perfecta.svc';
 }